import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import glovesImage from '../img/envision/digital/digitalizing-processes.webp';
import glovesImage2 from '../img/envision/digital/connecting-stakeholders.webp';
import glovesImage3 from '../img/envision/digital/enabling-seamless-user-experience.webp';
import glovesImage4 from '../img/envision/digital/accelerating-scalable-solutions.webp';

const products = [
  {
    name: 'Digitalizing',
    photo: glovesImage,
    brand: '2Pink',
    color: '#EB6CA4',
    description: 'AI/ML, MOM, and digital twin for optimizing processes',
  },
  {
    name: 'Enabling Seamless User Experience',
    photo: glovesImage2,
    brand: 'Coach',
    color: '#EFB2AF',
    description: 'Luxury belt with exquisite craftsmanship',
  },
  {
    name: 'Connecting Stakeholders',
    photo: glovesImage3,
    brand: 'Bvlgari',
    color: '#424242',
    description: 'Luxury belt with exquisite craftsmanship',
  },
  {
    name: 'Accelerating Scalable',
    photo: glovesImage4,
    brand: 'Bvlgari',
    color: '#424242',
    description: 'Elegant accessory with a modern twist',
  },
];

const Geospatialanimatedcards = () => {
  const settings = {
    dots: true,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div style={{ marginTop: '50px' }}>
      <h1 style={{ textAlign: 'center' }}>
        <span style={{ color: 'rgb(10 130 160)' }}>Digital Advisory</span> Services
      </h1>
      <Slider {...settings}>
        {products.map((product, index) => (
          <section key={index} className={`product-container product-${index + 1}`}>
            <div className="cards">
              <div className="photo">
                <img src={product.photo} alt={product.name} />
              </div>
              <div className="content">
                <h1 className="title">{product.name}</h1>
                <h2 className="bg-title">{product.brand}</h2>
                <div className="feature description">
                  <p>{product.description}</p>
                </div>
                <button className="btn-buy">Know more</button>
              </div>
            </div>
          </section>
        ))}
      </Slider>
      <style>
  {`

   .slick-slider {
      max-width: 1200px; /* Set a maximum width for the slider */
      margin: 0 auto; /* Center align the slider */
      padding: 20px; /* Add some padding for spacing */
    }

  
    .product-row {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 30px;
            margin-top: 50px;
          }

          .product-container {
            position: relative;
            width: 100%;
            max-width: 340px;
          }

          .cards {
            position: relative;
            width: 100%;
            height: 460px;
            background: #232323;
            border-radius: 20px;
            overflow: hidden;
            box-sizing: border-box;
          }

          .cards:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: var(--product-color);
            clip-path: circle(150px at 80% 20%);
            transition: 0.5s ease-in-out;
          }

          .cards:hover:before {
            clip-path: circle(300px at 80% -20%);
          }

          .title {
            position: relative;
            font-weight: 600;
            letter-spacing: 1px;
            color: #fff;
            margin-top: 12px;
            z-index: 20;
          }

          .bg-title {
            font-size: 4em;
            font-weight: 900;
            font-style: italic;
            color: rgba(255, 255, 255, 0.1);
            position: absolute;
            top: -150%;
            left: -20%;
            transition: 0.6s;
            z-index: 10;
          }

          .cards:hover .bg-title {
            transform: translateY(60%);
          }

          .photo {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 10;
            width: 100%;
            height: 220px;
            transition: 0.5s;
          }

          .cards:hover .photo {
            opacity: 0;
          }

          .photo img {
            position: absolute;
            width: 220px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-25deg);
            transition: 0.5s;
          }

          .cards:hover .photo img {
            width: 260px;
            top: 56%;
            opacity: 0;
          }

          .content {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 100px;
            transition: 1s;
            z-index: 10;
            opacity: 0;
          }

          .cards:hover .content {
            height: 190px;
            opacity: 1;
          }

          .feature {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 8px 20px;
            transition: 0.5s;
            visibility: visible;
            opacity: 1;
            color: #fff;
            margin-left: -65px;
          }

          .feature h3 {
            color: #fff;
            font-weight: 300;
            font-size: 14px;
            text-transform: uppercase;
            letter-spacing: 2px;
            margin-right: 10px;
          }

          .feature span {
            min-width: 20px;
            padding: 0 4px;
            height: 26px;
            text-align: center;
            line-height: 26px;
            font-size: 14px;
            display: inline-block;
            color: #111;
            background: #fff;
            margin: 0 5px;
            transition: 0.4s;
            border-radius: 4px;
            cursor: pointer;
          }

          .feature span:hover {
            color: #000;
            background: var(--product-color);
          }

          .btn-buy {
            display: inline-block;
            padding: 10px 20px;
            background: #fff;
            border: none;
            border-radius: 4px;
            margin-top: 10px;
            text-decoration: none;
            font-weight: 600;
            color: #111;
            opacity: 0;
            transform: translateY(50px);
            transition: 0.5s;
            cursor: pointer;
            outline: none;
          }

          .cards:hover .btn-buy {
            opacity: 1;
            transform: translateY(0px);
          }

          .cards:hover .btn-buy:hover {
            background: var(--product-color);
          }

          .product-1 {
            --product-color: #EB6CA4;
          }

          .product-2 {
            --product-color: #EFB2AF;
          }

          .product-3 {
            --product-color: #424242;
          }

          /* Responsive Styles */
          @media (max-width: 768px) {
            .product-row {
              justify-content: center;
              gap: 15px;
            }

            .product-container {
              width: 100%;
              max-width: 280px;
            }

            .cards {
              height: 400px;
            }

            .photo img {
              width: 180px;
              transform: translate(-50%, -50%) rotate(0deg);
            }

            .content {
              height: 150px;
            }
          }

          @media (max-width: 480px) {
            .product-row {
              flex-direction: column;
              align-items: center;
              gap: 20px;
            }

            .product-container {
              width: 100%;
              max-width: 300px;
            }

            .cards {
              height: 380px;
            }

            .photo img {
              width: 180px;
            }

            .content {
              height: 160px;
            }
          }

    .slick-dots li.slick-active button:before {
      color: rgb(10, 130, 160);
    }

    .slick-prev,
    .slick-next {
      z-index: 1;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .slick-prev:hover,
    .slick-next:hover {
      background: rgba(0, 0, 0, 0.7);
    }

    .slick-prev:before,
    .slick-next:before {
      font-size: 20px;
      color: #fff;
    }

    /* Responsive adjustments */
    @media (max-width: 1024px) {
      .cards {
        height: 400px;
      }
    }

    @media (max-width: 768px) {
      .cards {
        height: 350px;
      }

      .photo img {
        height: 150px;
      }

      .content {
        padding: 15px;
      }

      .title {
        font-size: 1.2rem;
      }

      .bg-title {
        font-size: 1rem;
      }

      .feature.description p {
        font-size: 0.9rem;
      }
    }
  `}
</style>

    </div>
  );
};

export default Geospatialanimatedcards;
